import React from 'react'
import { uniqBy, upperFirst } from 'lodash'

import Section from '../Section'
import Accordion from '../Accordion'
import BEMHelper from '../../helpers/bem'
import styles from './Styles.module.scss'

const bem = new BEMHelper(styles)

export default function CompetencyGoals({ data = [] }) {
  if (data.length === 0) {
    return null
  }

  const interdisciplinarySkills = uniqBy(
    data.reduce(
      (res, v) => [...res, ...(v?.interdisciplinarySkills || [])],
      [],
    ),
    'title',
  )

  return (
    <div {...bem('')} id="compentency-goals">
      <Section title="Kompetansemål">
        <ul {...bem('goals')} {...bem('list')}>
          {data.filter(Boolean).map((goal) => {
            const title =
              goal?.planTitle?.title !== goal?.competencyGoalSetTitle
                ? `${goal?.planTitle?.title} ${goal.competencyGoalSetTitle || ''}`
                : goal?.planTitle?.title

            return (
              <li key={goal._id} {...bem('item')}>
                <h3 {...bem('sub-title')}>{title}</h3>

                <p {...bem('body')}>{upperFirst(goal?.title)}.</p>

                {goal?.coreElements?.length > 0 && (
                  <Accordion title="Kjerneelementer" type="minimal">
                    <ul {...bem('body')}>
                      {(goal.coreElements || []).map((ce) => (
                        <li key={ce}>{ce}</li>
                      ))}
                    </ul>
                  </Accordion>
                )}
              </li>
            )
          })}
        </ul>
      </Section>

      {interdisciplinarySkills?.length > 0 && (
        <div>
          <h2 {...bem('title')}>Tverrfaglige temaer</h2>
          <ul>
            {interdisciplinarySkills?.map((skill) => (
              <li key={skill.code}>{skill.title}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
